import { RegistrationStatus } from '../../enum/registration-status.enum';
import { defaultEmptyMetricString, TIME_RESPONSAVEL_MANHATTAN } from './metric.interface';

/**
 * Dimensões fixas dos eventos de métrica do fluxo de recadastro
 * (Atualização Cadastral). Centralizadas para evitar strings soltas.
 */
export const RE_REGISTRATION_METRIC = {
    productAreaOrigin: 'Atualização Cadastral',
    timeResponsavel: TIME_RESPONSAVEL_MANHATTAN,
    /** Step usado nos eventos "genéricos" da visão geral (compatibilidade com dashboards atuais) */
    defaultStep: 'Atualizar dados cadastrais',
    notApplicable: defaultEmptyMetricString,
} as const;

/** Rótulos de step por etapa do funil */
export const RE_REGISTRATION_STEPS = {
    home: 'Home Atualização Cadastral',
    overview: 'Atualizar dados cadastrais',
    personalData: 'Dados Pessoais',
    contact: 'Contatos',
    address: 'Endereço',
    income: 'Renda e Patrimônio',
    documents: 'Envio de documentos',
    token: 'Inserir Token',
    success: 'Sucesso',
} as const;

/**
 * Traduz o registrationStatus do usuário para o rótulo de Status usado nas métricas.
 */
export function resolveReRegistrationStatus(
    registrationStatus: number | undefined | null,
): string {
    if (registrationStatus === RegistrationStatus.UserPreExpired) {
        return 'Pré Expirado';
    }
    if (registrationStatus === RegistrationStatus.UserExpired) {
        return 'Expirado';
    }
    return RE_REGISTRATION_METRIC.notApplicable;
}
